import React from "react";
import { Box, Paper, Typography, Button, Stack, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function AdminLanding() {
  const navigate = useNavigate();
  const { user, role } = useAuth();

  const isAdmin = role === "admin" || (user?.roles || []).includes("admin");

  return (
    <Box sx={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Paper elevation={4} sx={{ p: 4, width: "100%", maxWidth: 720, borderRadius: 3 }}>
        <Typography variant="h4" fontWeight={900} gutterBottom>
          InCooking Admin
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Διαχείριση προϊόντων, συνταγών, χρηστών και feedback.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          {isAdmin ? (
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/admin/dashboard")}
            >
              Πήγαινε στο Dashboard
            </Button>
          ) : (
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/admin-login")}
            >
              Login Admin
            </Button>
          )}

          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/admin/feedback")}
          >
            Feedback
          </Button>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          Αν γράψεις λάθος διεύθυνση, θα σε γυρίσει αυτόματα στη σελίδα login.
        </Typography>
      </Paper>
    </Box>
  );
}
